var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5556 29.0909L6.66667 21.8182L9.8 19.2545L15.5556 23.9455L30.2 11.9636L33.3333 14.5455M20 0L0 7.27273V18.1818C0 28.2727 8.53333 37.7091 20 40C31.4667 37.7091 40 28.2727 40 18.1818V7.27273L20 0Z",
    fill: "#85B6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrity);
export default __webpack_public_path__ + "static/media/Integrity.634a0a438382d33ec2021714ca257763.svg";
export { ForwardRef as ReactComponent };